import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal,Toast, Container, OverlayTrigger, Tooltip, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { isValidParam, formatearNumero } from '../../../../common/Formatos'


const Grilla = () => {
  const [show, setShow] = useState(false)
  const [listaGrilla, setListaGrilla] = useState(null)
  const [showCarpeta, setShowCarpeta] = useState(false)
  
  const data_solicitud_modal = useSelector((state) => state.solicitudDescuentoReducer)
  const data_modal_cia = useSelector((state) => state.modalCartaCiaTerceroReducer)
  const {solicitudDescuento} = data_modal_cia
  const { cfg_form17 } =
  data_solicitud_modal
  const handleShowCarpeta = () => setShowCarpeta(true)
   const handleCloseCarpeta= () => setShowCarpeta(false)
  const dispatch = useDispatch()

  useEffect(()=>{     
      setListaGrilla(solicitudDescuento && solicitudDescuento.solicitudDescuento)   
  },[solicitudDescuento])
 
 const obtenerColumnas = () => {
  return [
    {
      dataField: 'fecSolDctoFormat',
      text:cfg_form17? cfg_form17.cfg_form17[
        'soldescuento-grilla-fechasol'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'porcPropuestoSolDcto',
      text:cfg_form17?  cfg_form17.cfg_form17[
        'soldescuento-grilla-porcmonto'
      ]:'',
      formatter:(cell, row)=>{
        return `${cell}% / ${solicitudDescuento && formatearNumero(solicitudDescuento.solicitudDescuento[0]['montoPropuestoSolDcto'], 
          !(isValidParam((solicitudDescuento.solicitudDescuento)[0]['idMonedaSolDcto']) && solicitudDescuento.solicitudDescuento[0]['idMonedaSolDcto'] == 30001)) }`
      },
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'estadoSolicitud',
      text:cfg_form17?  cfg_form17.cfg_form17[
        'soldescuento-grilla-estado'
        
      ]:'',
      
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white',width:'30%' },
    
    },
    {
      dataField: 'comentarioRespuesta',
      text:cfg_form17?  cfg_form17.cfg_form17[
        'soldescuento-grilla-comrpta'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'fecRptFormat',
      text:cfg_form17?  cfg_form17.cfg_form17[
        'soldescuento-grilla-fecharpt'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
   
  ]
}
const handleShow=(row)=>{
  handleShowCarpeta()
}


  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-recepcionar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      
      <Container>
      
      <Row className='mt-4 mb-3'>
          <Col>
            <ToolkitProvider
                search
                bootstrap4
                keyField='secuencia'
                data={listaGrilla ? listaGrilla : []}
                columns={obtenerColumnas()}
                defaultSorted={[{ dataField: 'secuencia', order: 'asc' }]}
               
                >
                {(props) => (
                    <div>
                        <div className="rounded mt-4 mb-0" style={{backgroundColor:"#D1F2EB", color:"#4F517A"}}>
                            <h6 className="p-2">{cfg_form17.cfg_form17['soldescuento-grilla-title']}</h6>
                        </div>

                    <BootstrapTable
                        {...props.baseProps}
                        bordered={false}   
                       
                        headerWrapperClasses='table-secondary'
                        pagination={paginationFactory({ sizePerPage: 5})}
                        noDataIndication={
                        <div className='text-center'>
                            No hay registros encontrados
                        </div>
                        }
                    />
                    </div>
                )}
            </ToolkitProvider>
          </Col>
      </Row>
      </Container>
    </>
  )
}

export default Grilla
